export default __webpack_public_path__ + "images/graphics/buy-car-orange.png";